import { useMemo } from "react";

import { Dialog, Paper, Typography } from "@mui/material";

import {
  selectGeoCodeResult,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { Button } from "@covertree/ui";

import { getFullStateName } from "@utils/getFullStateName";

interface MissingAppointmentInNonJITStateModalProps {
  open: boolean;
  onClose: () => void;
}

export function MissingAppointmentInNonJITStateModal({
  open,
  onClose,
}: MissingAppointmentInNonJITStateModalProps) {
  const newHomeGeoCode = useNewBusinessSelector(selectGeoCodeResult);

  const fullStateName = useMemo(
    () => (newHomeGeoCode?.state ? getFullStateName(newHomeGeoCode.state) : ""),
    [newHomeGeoCode]
  );
  return (
    <Dialog open={open} onClose={onClose}>
      <Paper
        sx={{
          marginX: 5,
          marginY: 3,
          textAlign: "center",
          boxShadow: "none",
        }}>
        <Typography
          sx={{
            marginX: 3,
            marginY: 2,
          }}>
          Your appointment in{" "}
          <Typography
            component="span"
            sx={(theme) => ({ color: theme.colors.green3 })}>
            {fullStateName}
          </Typography>{" "}
          is still being processed. No action is needed right now - we’ll send
          you a follow-up email with confirmation as soon as it’s complete.
        </Typography>
        <Button sx={{ marginX: 3, marginY: 2 }} onClick={onClose}>
          Done
        </Button>
      </Paper>
    </Dialog>
  );
}
